import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { Bills } from "../utils/types/accounting";

export const fetchBillingCodeList = async () => {
  const response = await axiosServices.get("/accounting");
  return convertToCamelCase<Bills[]>(response.data.data);
};

export const updateBillingCodeData = async (
  id: string,
  data: {
    [key: string]: any;
    accountingId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/accounting/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const deleteBillingCodeData = async (id: string) => {
  const response = await axiosServices.delete(`/accounting/${id}`);
  return { success: response.data.success, id };
};

export const addBillingCodeData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/accounting`, inputData);
  return convertToCamelCase<Bills>(response.data.data);
};
